import React from 'react'
import ClassNames from 'classnames'
import { AccordionStyle } from './styled'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { ICONS_LINK } from '../../themes'
// import { ICONS } from '../../themes'

/**
 * Accordion Online List description
 * - ...
 */

class AccordionHead extends React.PureComponent {
  render() {
    const { id, children } = this.props
    const img = (
      // <img src="https://buyer.dev.srm.tspace.astrosystem.co/static/media/icon-arrow-down.198f2e08.svg" />
      <img src={ICONS_LINK('/static/media/icon-arrow-down.198f2e08.svg')} />
    )

    return (
      <AccordionSummary className="accordion-summary" expandIcon={img} id={id}>
        <FormControlLabel
          style={{ width: '100%' }}
          onClick={event => event.stopPropagation()}
          onFocus={event => event.stopPropagation()}
          control={children}
        />
      </AccordionSummary>
    )
  }
}

class AccordionBody extends React.PureComponent {
  render() {
    const { children } = this.props

    return (
      <AccordionDetails className="accordion-details">
        {children}
      </AccordionDetails>
    )
  }
}

export class AccordionOnlineList extends React.PureComponent {
  static Head = AccordionHead
  static Body = AccordionBody

  render() {
    const {
      className,
      children,
      disabled,
      isDisable,
      expanded,
      onChange,
    } = this.props

    return (
      <AccordionStyle
        className={ClassNames(
          'accordion-list',
          { 'is-disabled': disabled || isDisable },
          className
        )}
      >
        <Accordion
          expanded={expanded}
          onChange={() => {
            if (onChange) {
              onChange()
            }
          }}
        >
          {children}
        </Accordion>
      </AccordionStyle>
    )
  }
}
